//import liraries
import React, { Component, useEffect, useState } from "react";
import {View, ImageBackground,} from "react-native";
import CHeader from "../../common/CHeader";
import MainContainer from "../../common/CWrapper";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import TiCertificateCard from "./CommonComponants/TiCertificateCard";
import CustomButton from "../../common/CustomButton";
import { downloadTICertificate } from "../../api/tripInsurance";
import { openExternalURL } from "../../common/CHelper";
import Loader from "../../common/Loader";
import ModalAlert from "../../common/ModalAlert";

// create a component
const TiInsuranceCertificate = (props) => {
  console.log(props,"propsssssss1")
  const styles = useStyles();
  const [loading,setLoading] =useState(false)
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [alertModal, setAlertModal] = useState({
    title: "",
    status: "",
    message: "",
    navigateScreen: "",
    actionButton: "",
  });

  const onCloseModal = () => {
    setAlertModalVisible(false);
  };

  let policyData=props?.data?.policyData
  console.log(props,"props00000")
  let policyNumber = "N/A";
  let status = "Opted";
  if (policyData && policyData.activePolicy) {
    policyNumber = policyData.activePolicy?.coiNo;
    status = "Active";
  } else if (policyData && policyData.recurringPolicyOpted) {
    status = "Opted"
  }
  
  const getDownloadCertificateLink = () => {
      setLoading(true)
      const coiNumber = policyData.activePolicy?.coiNo;
    const params = { coiNumber };
      downloadTICertificate(policyData?.activePolicy?.coiNo)
      .then((resData) => {
        setLoading(false);
        console.log("getTIPolicyCertificate:", resData);
        if (resData.statusCode === 1099 && resData?.data) {
          openExternalURL(resData?.data?.COIDocumentLink, 'http');
        } else{
          setAlertModal({
            title: "Error",
            status: "error",
            message: "Unable to download the Certificate. Please try again after sometime.",
            navigateScreen: "",
            actionButton: "OK",
          });
          setAlertModalVisible(true)
        }
      }).catch((err) => {
        setAlertModal({
          title: "Error",
          status: "error",
          message: "Unable to download the Certificate. Please try again after sometime.",
          navigateScreen: "",
          actionButton: "OK",
        });
        setAlertModalVisible(true)
        setLoading(false);
        console.log("getTIPolicyCertificate Error:", err);
      });
    
  }
  
  return (
    <MainContainer>
      <View style={styles.contentWrapper}>
        <CHeader
        showBack
        disputeHeader
          title="Insurance Certificate"
          onPress={() => props.setScreen(props?.info?.backNavigation)}
          showDesc={true}
        />
        <View style={{ width: "100%", height: "100%",borderBottomRightRadius: 15,
              borderBottomLeftRadius: 15, }}>
          <ImageBackground
            source={require("../../assets/images/tiCertificateBgImage.png")}
            resizeMode={"cover"}
            style={styles.bgImage}
          >
            <View style={styles.certificateWidget}>
              <TiCertificateCard data={props?.data} />
            </View>
            <View style={styles.btnWidget}>
                <View style={styles.footerBtn}>
                <CustomButton  onPress={() => props.setScreen(props?.info?.backNavigation)} text={"Back"} borderColor= {"#ffffff"} width={139}  color = {"#ffffff"}skipButton/>
                </View>
                <View style={styles.btnDownload}>
                <CustomButton  onPress={() =>getDownloadCertificateLink()} text={"Download Certificate"} />
                </View>
               
            </View>
          </ImageBackground>
        </View>
      </View>
      {alertModalVisible && (
        <View style={styles.overlayViewStyle}>
          <ModalAlert
            title={alertModal.title}
            status={alertModal.status}
            message={alertModal.message}
            navigateScreen={alertModal.navigateScreen}
            actionButton={"OK"}
            onCloseModal={onCloseModal}
          />
        </View>
      )}
      {loading && <Loader />}
    </MainContainer>
  );
};

// define your styles
const useStyles = CreateResponsiveStyle(
  {
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#2c3e50",
  },
  bgImage:{
    width: "100%",
    height: "92%",
    borderBottomRightRadius: 15,
    borderBottomLeftRadius: 15,
    alignItems: "flex-end",
    justifyContent: "center",
  },
  overlayViewStyle: {
    position: "absolute",
    zIndex: 9999,
    backgroundColor: "rgba(52,52,52,0.9)",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    borderRadius: 10,
  },
  contentWrapper: {
    width: "100%",
    height: "100%",
  },
  certificateWidget:{ 
    width: 349, 
    height: 248,
     marginRight: "10%" 
    },
    btnWidget:{
      flexDirection:"row", 
      marginRight: "10%",
      marginTop:20
    },
    footerBtn:{
      width:139,
      height:40,
      marginRight:20
    },
    btnDownload:{
      width:193,
      height:40
    }

},
{
  [DEVICE_SIZES.SM]: {},
  [DEVICE_SIZES.XS]: {
    certificateWidget:{
      width:300,
      marginRight:10,
      marginTop:'12%'
    },
    footerBtn:{
      width:60,
      height:40,
      marginRight:10
    },
    btnDownload:{
      width:150,
      height:40
    },
    btnWidget:{
      marginRight:20,
      width:'90%',
      flexDirection:'row',
      justifyContent:'space-between'
    },
    bgImage:{
      height:'75%',
      justifyContent: "flex-start",
    }
  },
});

//make this component available to the app
export default TiInsuranceCertificate;
